import CheckHttpStatus from "fetch-check-http-status";

const fetchUpdateHelpfulReviewUpvotes = async (
  reviewId: number,
  isHelpful: boolean
): Promise<string> => {
  const data = new FormData();
  data.append("method", "reviewProductReview");
  data.append("review_num", String(reviewId));
  data.append("is_helpful", String(isHelpful));

  return fetch("/Object/MyAccount.cfc", {
    method: "POST",
    body: data,
  })
    .then(CheckHttpStatus)
    .then((response) => response.text());
};

export default fetchUpdateHelpfulReviewUpvotes;
